// /**
//  * Report Center Orders -CSV
//  */

// React
import React from 'react';

import {CSVLink} from 'react-csv';

// UI
import {Button} from '@material-ui/core';

//helper
import {translate} from '../../../utils/helpers';

import jMoment from 'moment-jalaali';
import RonadIcons from '../../../components/iconComponent';

type Props = {
  data: any;
  filtersValues: any;
  loading: any;
};

function CSV(props: Props) {
  const handleCreateCSV = () => {
    // props.ordersDispatch({ ...props.filtersValues, size: 10000 })
  };
  const flattData = (data: any) => {
    let newData = [] as any;
    data?.days.map((item: {date: string; values: number[]}, index: number) => {
      newData[index] = {
        تاریخ: jMoment(item.date, '').locale('fa').format(`jYYYY/jMM/jD`),
        ...createObject(data.statuses, item.values),
      };
    });
    return newData;
  };

  const createObject = (statuses: object[], values: number[]) => {
    return statuses.reduce(
      (o: any, key: any, index: number) => ({
        ...o,
        [translate(key, 'order')]: values[index],
      }),
      {}
    );
  };

  return (
    <>
      {Object.keys(props.data).length > 0 ? (
        <CSVLink
          data={flattData(props.data)}
          filename={`ReportCenterOrders.csv`}
          style={{
            backgroundColor: '#DFA01F',
            padding: '10px',
            color: '#fff',
            marginLeft: '5px',
            textDecoration: 'none',
          }}
        >
          دانلود اکسل
        </CSVLink>
      ) : (
        <Button
          style={{marginLeft: '5px'}}
          variant="contained"
          color="primary"
          startIcon={<RonadIcons name='tableArrowUp' size={1} />}
          onClick={handleCreateCSV}
          disabled={props.loading}
        >
          ایجاد فایل CSV
        </Button>
      )}
    </>
  );
}

export default CSV;
